import cn from "classnames"
import { Field, FieldProps } from "formik"
import React from "react"

import styles from "./index.module.css"

type Props = {
  label: string
  name: string
  value?: string
  onChange?: (checked: boolean) => void
  className?: string
}

export const FormCheckbox: React.FC<Props> = ({ label, name, value, onChange, className }) => (
  <Field name={name} type="checkbox" value={value}>
    {({ field }: FieldProps) => (
      <div className={cn(styles.Checkbox, className)}>
        <input
          {...field}
          id={`${name}_${label}`}
          type="checkbox"
          onChange={(e) => {
            field.onChange(e)
            if (onChange) {
              onChange(e.target.checked)
            }
          }}
        />
        <label htmlFor={`${name}_${label}`}>{label}</label>
      </div>
    )}
  </Field>
)
